import TooltipComponent from "components/TooltipComponent/TooltipComponent";
import BasketCard from "components/BasketCard/BasketCard.vue";

import { computed } from "vue";
import { useStore } from "vuex";

export default {
    name: "BasketAside",
    components: { TooltipComponent, BasketCard },
    props: {
        miniBasket: {
            type: Boolean,
            required: false,
            default: false,
        },
        showPaymentOptions: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    setup(props) {
        const store = useStore();
        const basketCards = computed(() => store.state.basket.basket);
        const totals = computed(() => store.state.basket.totals);
        const hasErrors = computed(
            () => store.state.basket.basketState.hasErrors,
        );

        const getLabel = (labelKey, allowEmpty = false) =>
            store.getters["labels/getLabel"]({
                labelCollection: "basketAside",
                labelKey: labelKey,
                allowEmpty,
            });
        const displayObsMessage = computed(() =>
            store.state.basket.totals?.isShippingFree ?? false
                ? ""
                : "kb-product-detail__error-message--show",
        );

        const displayBasketErrorMessageClass = computed(() =>
            !hasErrors.value ? "" : "kb-product-detail__error-message--show",
        );

        return {
            displayObsMessage,
            displayBasketErrorMessageClass,
            basketCards,
            asideResults: totals,
            getLabel,
            hasErrors,
        };
    },
};
